module.exports = __webpack_public_path__ + "a2bff4aa1a5287e16ed89a3c8233137b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-de.html
// module id = 1039
// module chunks = 0